import { render } from "./TableQuestion.vue?vue&type=template&id=3fb82f63&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"

import "./TableQuestion.vue?vue&type=style&index=0&id=3fb82f63&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb82f63"]])

export default __exports__